<style scoped>
.action-tab-select-down {
  text-align: left;
}

.workflow-map-fields {
  width: 100%;
}

.map-fields-name {
  width: 100% !important;
}

.action-dropdown-toggle {
  background: none;
  border: none;
  font-weight: 400;
  color: #00a8ff;
  padding: 2px;
  font-size: 12px;
}

.map-fields-name-action {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
}

.map-fields-name-action-input {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
  margin-top: 16px;
}

.map-fields-name-action sup {
  color: #ff0000;
}

.map-fields-name-action-input sup {
  color: #ff0000;
}

.workflow-map-fields-items a:after {
  content: none;
}

.action-tab-select-down-menu ul li a {
  margin-left: 0;
  padding-left: 10px;
}

.action-tab-select-down-menu {
  width: 200px;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

.wf-task-tab-content a:after {
  content: none;
}

.send-mail-inputs {
  margin-top: 0;
  height: auto;
  padding: 2px 0px;
  width: 100% !important;
}

.workflow-accordion-container-modify {
  overflow-y: auto;
  padding: 0 14px 10px 14px;
  position: relative;
  /*height: 300px;*/
  min-height: 330px;
}

.content-error {
  font-size: 12px;
  color: red;
}

#automated-section .full-width-dialog {
  min-width: 60% !important;
  height: 92vh;
}

#automated-section .workflow-map-fields-container {
  padding: 25px;
  height: calc(100% - 237px);
  overflow-y: auto;
}

#automated-section .automation_template_editor {
  height: calc(100vh - 400px);
}

.reset-btn {
  display: flex;
  padding-left: 0.5em;
}
</style>

<template>
  <!-- Modal -->
  <div class="modal fade automation_action_modal_main" id="send-email-modal" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg-custom full-width-dialog" role="document">
      <div class="modal-content automation_action_modal_content">
        <div class="modal-body workflow-modal-body">
          <div class="border-body-right-top"></div>
          <div class="workflow-email-header">
            <h2>{{ lang.send_email }}</h2>
            <div class="wf-tab-email-main-container">
              <form>
                <div class="wf-task-tab-container">
                  <div class="wf-task-tab-content wf-task-anchor">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="map-fields-name-action">{{ lang.from }}<sup>*</sup></div>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down">
                          <input class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                 v-bind:id="'mapFieldEmail-'+'from'"
                                 v-bind:class="{ 'is-invalid-popup': send_email_error.from == true  }"
                                 v-on:click.stop.prevent="modifyAccordion('from')" type="button"
                                 :value="containsKey(MapValuesEmail, 'from')" data-toggle="dropdown"
                                 aria-haspopup="true" aria-expanded="false"/>

                          <div class="popup-container-main" v-if="checkActiveDD('from')"
                               :id="'popup-container-main-'+level">
                            <div class="popup-container popup-container-modify">
                              <div class="popup-search-filter">
                                <div class="workflow-selected-field">
                                  <span>{{ lang.select + ' ' + lang.field }}</span>
                                </div>
                              </div>
                              <div class="workflow-accordion-container-modify" v-click-outside="outside">
                                <AccordionForSendMail
                                    :field-id="'from'"
                                    :SelectedTableExcludedColumnList="emilFrom(SelectedTableExcludedColumnListEmail)"
                                    :level="level"
                                    :lang="lang"
                                    :MapValuesEmail="MapValuesEmail"
                                    :SelectedTableLabel="SelectedTable.label"
                                    v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                    :custom="false"
                                    :fields="UserTable"
                                    :executeHandler="executeHandler"
                                ></AccordionForSendMail>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="reset-btn">
                          <button
                              class="close close-custom position-absolute"
                              v-if="hasSelectedDataEmail(MapValuesEmail,'from')"
                              v-on:click.stop.prevent="removeSelectedItemEmail(MapValuesEmail,'from')"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="wf-task-tab-content wf-task-anchor">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="map-fields-name-action">{{ lang.recipient }}<sup>*</sup></div>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down">
                          <input class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                 v-bind:id="'mapFieldEmail-'+'recipient'"
                                 v-bind:class="{ 'is-invalid-popup': send_email_error.recipient == true  }"
                                 v-on:click.stop.prevent="modifyAccordion('to')" type="button"
                                 :value="containsKey(MapValuesEmail, 'recipient')" data-toggle="dropdown"
                                 aria-haspopup="true" aria-expanded="false"/>

                          <div class="popup-container-main" v-if="checkActiveDD('to')"
                               :id="'popup-container-main-'+level">
                            <div class="popup-container popup-container-modify">
                              <div class="popup-search-filter">
                                <div class="workflow-selected-field">
                                  <span>{{ lang.select + ' ' + lang.field }}</span>
                                </div>
                              </div>
                              <div class="workflow-accordion-container-modify" v-click-outside="outside">
                                <AccordionForSendMail
                                    :field-id="'recipient'"
                                    :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListEmail"
                                    :level="level"
                                    :lang="lang"
                                    :SelectedTableLabel="SelectedTable.label"
                                    :MapValuesEmail="MapValuesEmail"
                                    :custom="true"
                                    v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                    :fields="ContactTable"
                                    :executeHandler="executeHandler"
                                ></AccordionForSendMail>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="reset-btn">
                          <button
                              class="close close-custom position-absolute"
                              v-if="hasSelectedDataEmail(MapValuesEmail,'recipient')"
                              v-on:click.stop.prevent="removeSelectedItemEmail(MapValuesEmail,'recipient')"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="wf-task-tab-content wf-task-anchor">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="map-fields-name-action">{{ lang.cc }}</div>
                      </div>
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down">
                          <input
                              class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                              v-bind:id="'mapFieldEmail-cc'"
                              v-bind:class="{ 'is-invalid-popup': send_email_error.cc == true  }"
                              v-on:click.stop.prevent="modifyAccordion('cc')"
                              type="button"
                              :value="containsKey(MapValuesEmail, 'cc')"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"/>

                          <div class="popup-container-main" v-if="checkActiveDD('cc')"
                               :id="'popup-container-main-'+level">
                            <div class="popup-container popup-container-modify">
                              <div class="popup-search-filter">
                                <div class="workflow-selected-field">
                                  <span>{{ lang.select + ' ' + lang.field }}</span>
                                </div>
                              </div>
                              <div class="workflow-accordion-container-modify" v-click-outside="outside">
                                <AccordionForSendMail
                                    :field-id="'cc'"
                                    :SelectedTableExcludedColumnList="SelectedTableExcludedColumnListEmail"
                                    :level="level"
                                    :lang="lang"
                                    :custom="true"
                                    :SelectedTableLabel="SelectedTable.label"
                                    :MapValuesEmail="MapValuesEmail"
                                    v-on:SelectedMailToFromDetailsEvent="SelectMapField"
                                    :fields="ContactTable"
                                    :executeHandler="executeHandler"
                                ></AccordionForSendMail>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="reset-btn">
                          <button
                              class="close close-custom position-absolute"
                              v-if="hasSelectedDataEmail(MapValuesEmail,'cc')"
                              v-on:click.stop.prevent="removeSelectedItemEmail(MapValuesEmail,'cc')"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="wf-task-tab-content">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="map-fields-name-action">{{ lang.subject }}<sup>*</sup></div>
                      </div>
                      <div class="col-md-9">
                        <input type="text" v-model="MapValuesEmail.subject"
                               v-bind:class="{ 'is-invalid': send_email_error.subject == true  }" name="task"
                               class="wf-task-input send-mail-inputs" placeholder="Enter subject">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 editor-col automation_template_editor">
                      <editor
                          api-key="ark2od11b4yseas05mfof68fjpjte4ambcy2pfj5ikmu8fwh"
                          v-model="MapValuesEmail.content"
                          :init="init"
                          id='automation-save-email-action'
                      ></editor>

                      <div v-if="send_email_error.content">
                        <p class="content-error"> *Content can not be empty!</p>
                      </div>

                      <div v-show="showDropZone" class="form-group mt-9">
                        <div class="pt-2 display-attachments-automation">Email Attachments</div>
                        <vue-dropzone
                            :id="'customdropzone-'+level"
                            class="custom_dzone"
                            ref="dropzone"
                            :options="dropOptions"
                            @vdropzone-file-added="fileAdded"
                            @vdropzone-removed-file="removeFile"
                        ></vue-dropzone>
                      </div>

                      <div class="pt-1"
                           v-if="MapValuesEmail.attachedPdfs != undefined ? MapValuesEmail.attachedPdfs.length > 0 : ''">
                        PDF Attachments
                      </div>
                      <div class="display-pdfs-automation">
                        <div v-for="pdf in renderingPdfList" class="pl-2">
                          {{ pdf.name + `.pdf` }}
                          <i class="fa fa-times ml-2" @click="removePdf(pdf.id)" style="cursor: pointer"
                             data-dz-remove></i>
                        </div>
                      </div>


                      <div class="pt-1"
                           v-if="xmlList.length">
                        XML Attachments
                      </div>
                      <div class="display-pdfs-automation">
                        <div v-for="(xml, index) in xmlList" class="pl-2">
                          {{ xml.template.name }} <span v-if="xml.filter"> ({{ xml.filter.name }}) </span>
                          <i class="fa fa-times ml-2" @click="removeXML(index)" style="cursor: pointer"
                             data-dz-remove></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default wf-modal-cancel" data-dismiss="modal">
            {{ lang.cancel }}
          </button>
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="SaveAction()">
            {{ lang.save }}
          </button>
        </div>
      </div>
    </div>
    <EmailPDFModal
        :templateList="TemplateList"
        :selectedPdfList="MapValuesEmail.attachedPdfs != undefined ? MapValuesEmail.attachedPdfs : []"
        v-if="showPdfModal"
        :modalId="actionIndex+'-'+level+'-saved'"
        v-on:pdflistchangedEvent="selectedPdfs"
    />

    <AttachXMLModal
        v-if="SelectedTableId"
        :table="SelectedTableId"
        :modalId="actionIndex+'-'+level+'-saved'"
        v-on:addXMLFilterEvent="addXMLFilterForAction"
    />

    <div class="modal fade" id="email-record-placeholder-modal" tabindex="-1" role="dialog"
         aria-labelledby="email-record-placeholder-modal"
         aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="relation-title">Choose Fields</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="placeholder-body">
            <div class="fields">
              <div class="mt-1 mb-2 ml-1"><b>Select Columns</b></div>
              <select id="record-picker" class="form-control picker d-inline-block" multiple
                      v-model="selected_record_fields">
                <option :value="field.name" v-for="field in this.SelectedTable.fields">
                  {{ field.label }}
                </option>
                <option value="@record_url">Record URL</option>
              </select>
            </div>

            <div class="row mt-3 record-holder-options">
              <div class="col-12">
                <div><b>Group Record By</b></div>
                <select id="record-group-by" class="form-control d-inline-block" v-model="group_by_field">
                  <option value="">Select Field</option>
                  <option :value="field.id" v-for="field in this.SelectedTable.fields">
                    {{ field.label }}
                  </option>
                </select>
              </div>

              <div class="col-12 mt-1">
                <div class="row">
                  <div class="form-group form-check show-field-names">
                    <input type="checkbox" id="show-field-names" v-model="display_fields" true-value="true"
                           false-value="false"> Display Field Names
                  </div>

                  <div class="form-group form-check show-next-line">
                    <input type="checkbox" id="show-next-line" v-model="print_new_line" true-value="true"
                           false-value="false"> Print values on separate line
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button type="button" class="btn btn-primary apply-btn-color m-auto" @click="selectRecordPlaceholder">Add
              Placeholder
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/imagetools';

import Editor from '@tinymce/tinymce-vue';
import vueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import EmailPDFModal from '../EmailPDFModal.vue';
import AttachXMLModal from "../AttachXMLModal";

export default {
  name: 'CreateTaskModal',
  props: [
    'SelectedTableId',
    'entity_id',
    'url',
    'level',
    'SelectedTable',
    'whenshould',
    'SelectedTableExcludedColumnListEmail',
    'lang',
    'TemplateList',
  ],
  components: {
    'editor': Editor,
    vueDropzone,
  },
  data() {
    return {
      // editor

      init: {
        language_url : `/tinymce/langs/${ $('meta[name="language"]').attr('content') }.js`,
        language: $('meta[name="language"]').attr('content'),
        branding: false,
        selector: '#automation-save-email-action',
        height: 300,
        plugins: [
          'link', 'image', 'code', 'preview'
        ],
        disabled: false,
        contextmenu_never_use_native: 'link',
        relative_urls: false,
        paste_data_images: true,
        urlconverter_callback: function (url, node, on_save, name) {
          return url;
        },
        toolbar: 'undo redo | Template | variable | attach_file | Attach_PDFs | AttachXML | image | styleselect | bold italic | alignleft aligncenter alignright alignjustify | table | fontsizeselect',

        setup: (editor) => {
          this.mceEditor = editor;
          /*Email template list*/

          editor.ui.registry.addMenuButton('Template', {
            text: this.templateBtnName,
            fetch: (callback) => {

              var template_items = [];

              for (const _temp in this.TemplateList) {

                if (this.TemplateList[_temp].type == 'email') {

                  var _items = {
                    type: 'menuitem',
                    text: this.TemplateList[_temp].name,
                    onAction: () => {
                      tinyMCE.get('automation-save-email-action').setContent('');
                      this.MapValuesEmail.subject = this.TemplateList[_temp].subject;
                      editor.insertContent(this.TemplateList[_temp].content);
                    }
                  };

                  template_items.push(_items);
                }
              }

              callback(template_items);
            }
          });

          editor.ui.registry.addButton('Attach_PDFs', {
            text: translation.attach_pdfs,
            onAction: () => {
              $('#email-pdf-modal-' + this.actionIndex + '-' + this.level + '-saved').draggable({
                handle: ".modal-header"
              });
              $('#email-pdf-modal-' + this.actionIndex + '-' + this.level + '-saved').modal('show');
              this.showPdfModal = false;
              this.showPdfModal = true;
            }
          });

          editor.ui.registry.addButton('AttachXML', {
            text: translation.attach_xml,
            onAction: () => {
              $('#email-xml-modal-' + this.actionIndex + '-' + this.level + '-saved').modal('show');
            }
          });

          /*Email template variable*/

          editor.ui.registry.addMenuButton('variable', {
            text: 'Add Field',
            fetch: (callback) => {

              var field_variables = [];
              var __table = this.SelectedTable;

              for (const _temp in __table.fields) {

                var _variable_items = {
                  type: 'menuitem',
                  text: __table.label + '.' + __table.fields[_temp].label,
                  onAction: () => {
                    editor.insertContent(
                        '${' + __table.fields[_temp].name + '}'
                    );
                  }
                };

                field_variables.push(_variable_items);
              }

              for (const _temp in __table.SelectedTableExcludedColumnListReationship) {

                var _variable_items = {
                  type: 'menuitem',
                  text: __table.label + '.' + __table.SelectedTableExcludedColumnListReationship[_temp].label,
                  onAction: () => {
                    editor.insertContent(
                        '${' + __table.SelectedTableExcludedColumnListReationship[_temp].name + '}'
                    );
                  }
                };

                field_variables.push(_variable_items);
              }

              var _variable_items = {
                type: 'menuitem',
                text: 'Record URL',
                onAction: () => {
                  editor.insertContent(
                      '@record_url'
                  );
                }
              };

              field_variables.push(_variable_items);

              var _variable_items = {
                type: 'menuitem',
                text: 'Record',
                onAction: () => {
                  let $modal = $('#email-record-placeholder-modal')
                  $('.picker').selectpicker({
                    container: 'body',
                    noneSelectedText: translation.nothing_selected
                  });
                  $modal.modal('show');
                }
              };
              field_variables.push(_variable_items);
              callback(field_variables);
            }
          });

          /*Attach file*/

          editor.ui.registry.addButton('attach_file', {
            text: 'Attach Files',
            onAction: () => {
              this.attachFiles(event);
            }
          });
        },
      },
      mceEditor: null,
      selected_record_fields: [],
      group_by_field: "",
      print_new_line: "false",
      display_fields: "false",
      showPdfModal: false,
      showXMLModal: false,
      renderingPdfList: [],
      selectedPdfList: [],
      xmlList: [],
      actionIndex: -1,

      dropOptions: {
        url: "/mail",
        thumbnailWidth: 40, // px
        thumbnailHeight: 40,
        addRemoveLinks: false,
        maxFilesize: 25, // MB
        previewTemplate: this.template(),
        autoProcessQueue: false,
        parallelUploads: 10,
        uploadMultiple: true,
      },

      templateBtnName: 'Template',
      ContactTable: [],
      MapValuesEmail: [],
      Data: [],
      data_status: null,
      ActiveAccordion: [],
      UserTable: [],
      executeHandler: null,
      showDropZone: false,

      // for validation
      send_email_error: {
        from: false,
        recipient: false,
        cc: false,
        subject: false,
        content: false,
      },
    }
  },
  mounted() {
    axios.post('/contact-table-data').then(response => {
      if (response.data.success) {
        this.ContactTable = response.data.result;
        this.UserTable = response.data.result;
      }
    });

    $(document).on('focusin', function (e) {
      if ($(e.target).closest(".tox-dialog").length) {
        e.stopImmediatePropagation();
      }
    });
  },
  watch: {
    SelectedTableId() {
      this.GetContactTableData();
    },
    whenshould() {
      this.executeHandler = this.whenshould;
    },
  },
  methods: {

    template: function () {
      return `<div class="dz-preview dz-file-preview">
                        <div class="dz-details">
                            <div>
                                <div class="upload-details">
                                    <b><span data-dz-name></span></b>

                                    (<span data-dz-size></span>)

                                    <i class="fa fa-times ml-2" style="cursor: pointer" data-dz-remove></i>
                                </div>

                                <div class="upload-progress">
                                    <span class="dz-progress">
                                        <span class="dz-upload" data-dz-uploadprogress></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="dz-error-message"><span data-dz-errormessage></span></div>
                        <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                        <div class="dz-error-mark"><i class="fa fa-times"></i></div>
                    </div>
                `;
    },

    selectRecordPlaceholder(e) {
      let placeholder = '',
          $modal = $('#email-record-placeholder-modal');
      if (this.selected_record_fields.length) {
        let options = {
          record_group_by: this.group_by_field,
          show_field_names: this.display_fields,
          show_next_line: this.print_new_line
        };
        placeholder = `@record([[${JSON.stringify(options)}],[${JSON.stringify(this.selected_record_fields)}]])`;
        $modal.modal('hide');
        this.mceEditor.insertContent(placeholder);
      }
    },
    addXMLFilterForAction(filter) {
      this.xmlList.push(filter);
    },

    selectedPdfs(values) {
      this.MapValuesEmail.attachedPdfs = values;
      this.getSelectedPdf(this.MapValuesEmail.attachedPdfs);
    },
    getSelectedPdf(_pdfList) {

      this.renderingPdfList = [];

      for (var pdf in _pdfList) {
        var _index = this.TemplateList.findIndex(x => x.id == _pdfList[pdf]);
        if (_index > -1) {
          this.renderingPdfList.push({
            'name': this.TemplateList[_index].name,
            'id': this.TemplateList[_index].id,
          });
        }
      }
    },

    removePdf(pdf_id) {

      var _index = this.renderingPdfList.findIndex(x => x.id == pdf_id);
      if (_index > -1) {
        this.renderingPdfList.splice(_index, 1);
      }

      var existingPdf = [];

      for (var x in this.renderingPdfList) {
        existingPdf.push(this.renderingPdfList[x].id);
      }

      this.MapValuesEmail.attachedPdfs = existingPdf;
    },
    removeXML(index) {
      this.xmlList.splice(index, 1);
    },
    fileAdded(event) {
      this.showDropZone = true;
    },

    removeFile(file) {
      if (!this.$refs.dropzone.getQueuedFiles().length &&
          !this.$refs.dropzone.dropzone.files.length) {
        this.showDropZone = false;
      }
    },
    attachFiles(event) {
      event.preventDefault();
      $('#customdropzone-' + this.level).click();
    },

    hasSelectedDataEmail(mappingData, field) {

      if (field == 'from') {
        if (mappingData['from']) {
          return true;
        }
        return false;

      } else if (field == 'recipient') {
        if (mappingData['recipient']) {
          return true;
        }
        return false;

      } else if (field == 'cc') {
        if (mappingData['cc']) {
          return true;
        }
        return false;

      } else if (field == 'category') {
        if (mappingData['category']) {
          return true;
        }
        return false;

      } else if (field == 'responsible') {
        if (mappingData['responsible']) {
          return true;
        }
        return false;
      }
    },
    removeSelectedItemEmail(mappingData, field) {
      mappingData[field] = null;

      if (document.getElementById('mapFieldTaskDD-' + field)) {
        document.getElementById('mapFieldTaskDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }

      if (document.getElementById('mapFieldEmailDD-' + field)) {
        document.getElementById('mapFieldEmailDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }
    },
    emilFrom(emailFromList) {
      let FromList = {};
      for (let x in emailFromList) {
        if (emailFromList[x].name != 'email_address') {
          FromList[x] = emailFromList[x];
        }
      }
      return FromList;
    },
    LoadDefaults(action_id, _data = null, _data_status = null) {
      // reset the form
      this.MapValuesEmail = [];
      this.$refs.dropzone.removeAllFiles();

      // Get saved data from db for edit action modal
      if (status != null) {
        this.data_status = _data_status;
      } else {
        this.data_status = null;
      }

      if (_data == null) {
        axios.post('/get-data-for-edit-modal', {'action_id': action_id}).then(response => {
          if (response.data.success) {
            this.MapValuesEmail = response.data.result.action_map.send_email;
            this.DropZoneFiles(this.MapValuesEmail.files);
            if (this.MapValuesEmail.xmlList !== undefined) {
              this.xmlList = this.MapValuesEmail.xmlList;
            }
            if (this.MapValuesEmail.attachedPdfs == undefined) {
              this.MapValuesEmail['attachedPdfs'] = [];
            }
            this.getSelectedPdf(this.MapValuesEmail.attachedPdfs);
            this.Data = response.data.result;
            this.showPdfModal = true;
          }
        });
      } else {
        this.MapValuesEmail = _data.send_email.send_email;
        this.DropZoneFiles(this.MapValuesEmail.files);
        if (this.MapValuesEmail.attachedPdfs == undefined) {
          this.MapValuesEmail['attachedPdfs'] = [];
        }
        if (this.MapValuesEmail.xmlList !== undefined) {
          this.xmlList = this.MapValuesEmail.xmlList;
        }
        this.getSelectedPdf(this.MapValuesEmail.attachedPdfs);
        this.Data = _data;
        this.showPdfModal = true;
      }

      this.actionIndex = action_id;

    },

    DropZoneFiles(Dz_Files) {
      /*Saved or temp attachments files push on dropzone*/

      for (var x in Dz_Files) {
        var image = Dz_Files[x];
        image.accepted = true;
        image.upload = {
          filename: image.name,
        };
        image.dataURL = image.file_path;
        image.status = 'complete';
        this.$refs.dropzone.manuallyAddFile(image, image.dataURL, {
          addToFiles: true
        });

        this.$refs.dropzone.dropzone.uploadFiles(image);
      }

      /*Saved or temp attachments files push on dropzone*/
    },
    checkActiveDD(field) {
      var _index = this.ActiveAccordion.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    modifyAccordion(label) {
      var _index = this.ActiveAccordion.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordion = [];
        this.ActiveAccordion.push(label);
      } else {
        this.ActiveAccordion = [];
      }
    },
    outside() {
      this.ActiveAccordion = [];
    },
    // get data from contact table
    GetContactTableData() {
      axios.post('/contact-table-data').then(response => {
        if (response.data.success) {
          this.ContactTable = response.data.result;
        }
      });
    },
    SelectMapField(event = null, field_id, field_dd) {
      this.MapValuesEmail[field_id] = field_dd;

      if (field_dd.record_type == 'old') {
        document.getElementById('mapFieldEmail-' + field_id).value = field_dd.selected_field.label != undefined ? this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.label : this.lang.old + ' ' + this.lang.record + '.' + field_dd.selected_field.name;
      } else {
        document.getElementById('mapFieldEmail-' + field_id).value = field_dd.selected_field.label != undefined ? field_dd.selected_field.label : field_dd.selected_field.name;
      }

      this.outside();
    },
    SaveAction() {
      // for validation
      let input_flag = 0;

      let skipFields = ['cc', 'files', 'attachedPdfs', 'xmlList'];
      for (let validatedField in this.MapValuesEmail) {
        if (!skipFields.includes(validatedField)) {
          if (
              !this.MapValuesEmail[validatedField] ||
              this.MapValuesEmail[validatedField] === '' ||
              this.MapValuesEmail[validatedField] === null
          ) {
            this.send_email_error[validatedField] = true;
            input_flag = 1;
            toastr.error(this.lang.required + ' ' + this.lang[error] + ' ' + this.lang.field_not_set, this.lang.failed);

            return false;
          } else {
            this.send_email_error[validatedField] = false;
          }
        }
      }
      if (input_flag == 0) {
        this.SaveActionAfterValidation();
      }

    },

    SaveActionAfterValidation() {
      let data = {};

      if (this.data_status == "saved") {
        data = {
          action_id: this.entity_id,
          send_email: {
            send_email: {
              content: this.MapValuesEmail.content,
              from: this.MapValuesEmail.from,
              recipient: this.MapValuesEmail.recipient,
              cc: this.MapValuesEmail.cc,
              subject: this.MapValuesEmail.subject,
              files: [],
              attachedPdfs: this.MapValuesEmail.attachedPdfs,
              xmlList: this.xmlList
            },
            level: this.Data.level
          }
        };
      } else {
        data = {
          action_id: null,
          send_email: {
            send_email: {
              content: this.MapValuesEmail.content,
              from: this.MapValuesEmail.from,
              recipient: this.MapValuesEmail.recipient,
              cc: this.MapValuesEmail.cc,
              subject: this.MapValuesEmail.subject,
              files: [],
              attachedPdfs: this.MapValuesEmail.attachedPdfs,
              xmlList: this.xmlList
            },
            level: this.Data.send_email.level
          }
        };
      }


      let formData = new FormData();
      var files = this.$refs.dropzone.dropzone.files;

      if (this.$refs.dropzone.dropzone.files.length > 0) {

        for (var i = 0; i < files.length; i++) {
          const file = files[i];
          if (file.status != 'complete') {
            formData.append('files[' + i + ']', file);
          } else {
            formData.append('previousExistFiles[' + i + ']', JSON.stringify(file));
          }
        }
      }

      this.tempAttachment(formData, data);

      this.$refs.dropzone.removeAllFiles();
      $('#send-email-modal').modal('hide');
    },

    tempAttachment(formData, data) {

      var files_name_array = null;

      for (var x in this.MapValuesEmail.files) {
        const uploaded_file = JSON.stringify(this.MapValuesEmail.files[x]);
        formData.append('allTempUploadedFiles[' + x + ']', uploaded_file);
        // all files without remove
      }

      let automation_id = null;

      if (this.Data.automation_id != undefined) {
        automation_id = this.Data.automation_id;
      }

      formData.append('automation_id', automation_id);

      /*Upload In temp folder In attachments start*/

      axios.post('/upload-attachments-temp', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        files_name_array = response.data;
        data.send_email.send_email.files = files_name_array;
        this.$emit('UpdateEmailActionEvent', data);
      });
    },
    containsKey(obj, key) {
      const contentExists = [
        'created_by',
        'modified_by',
        'assigned_to',
        'email_address'
      ];

      // console.log();
      if (obj[key] != undefined && obj[key]['selected_field'] != undefined && obj[key]['selected_field']['type'] != undefined && obj[key]['selected_field']['type'] == 'email') {
        contentExists.push(obj[key]['selected_field']['name']);
      }


      if (obj.hasOwnProperty(key)) {
        if (obj[key] != null) {

          if (obj[key].record_type == 'new') {
            return contentExists.includes(obj[key].selected_field.name) && obj[key].selected_field.label != undefined ? obj[key].selected_field.label : (obj[key].selected_field.email ? obj[key].selected_field.email : obj[key].selected_field.name);
          } else {
            return contentExists.includes(obj[key].selected_field.name) && obj[key].selected_field.label != undefined ? this.lang.old + ' ' + this.lang.record + '.' + obj[key].selected_field.label : this.lang.old + ' ' + this.lang.record + '.' + obj[key].selected_field.name;
          }
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      } else {
        return this.lang.select + ' ' + this.lang.value;
      }
    },
  }


}
</script>
